var map = {
	"./icon-ellipsis.svg": "5bdf",
	"./icon-exercise.svg": "5160",
	"./icon-play.svg": "1f8f",
	"./icon-self-care.svg": "2220",
	"./icon-social.svg": "4ad3",
	"./icon-study.svg": "0b43",
	"./icon-work.svg": "0f83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c844";